<script lang="ts" setup>
import type { Contacts } from '~~/server/api/insurance/bank/insurance'

export interface PagesBankInsuranceContactsProps {
    data: Contacts
}
const props = defineProps<PagesBankInsuranceContactsProps>()
</script>
<template>
  <section
    id="kontakty"
    class="mt-12 pt-12 mt-md-20 pt-md-20 border-top mb-12 mb-md-20 scroll-margin-top-11"
  >
    <BoxHeader
      heading-level="h2"
      :heading="$t('Kontakty')"
    />
    <LazyPagesBankInsuranceContacts
      class="mb-14"
      :data="props.data.contact"
    />
    <h3 class="gamma text-center mb-9">
      {{ $t('Asistenčné služby') }}
    </h3>
    <LazyPagesBankInsuranceContacts
      class="mb-12"
      :data="props.data.call_centrum"
    />
  </section>
</template>
